import Model from './model.js'
export default {
  LoadCurrencies:function(params){
      Model.Read(params)
  },
}



// WEBPACK FOOTER //
// ./src/App/helper/ADODB/super/currency/presenter.js